<template>
  <div>
    <span
      v-if="showTitle"
      class="mr-3"
      :class="{'float-left': floated}"
    >
      {{ actor.title }}
    </span>
    <display-status-value :actor="actor" :only-text="onTile" />
  </div>
</template>

<script>
import DisplayStatusValue from '@/components/services/service/DisplayStatusValue';

export default {
  name: 'Status',
  components: { DisplayStatusValue },
  props: {
    actor: {
      type: Object,
      required: true,
    },
    showTitle: Boolean,
    floated: Boolean,
    onTile: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
</style>
